import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import performRequest from "../../api/request";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import { FcPaid } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";

const RecipeView = () => {
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [loading, setLoading] = useState(true);

  /* ================= FETCH PRODUCT ================= */
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await performRequest(
          "GET",
          `/pmg/recipes/get-recipe/${id}`
        );

        if (res.status === 200) {
          let { epg_deals, ...rest } = res.data.data;

          const RecipeData = {
            ...rest,
            deals: epg_deals,
          };

          setData(RecipeData);

          // ✅ Default Variant
          if (RecipeData?.variants?.length > 0) {
            setSelectedVariant(RecipeData.variants[0]);
          }

          // ✅ Default Image
          const imgs = [
            RecipeData?.image,
            ...(RecipeData?.images || []),
          ].filter(Boolean);

          setSelectedImage(imgs[0]);
        }
      } catch (err) {
        console.log("API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchProduct();
  }, [id]);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: 50 }}>Loading...</div>;
  }

  if (!data) {
    return <div>No Product Found</div>;
  }

  const images = [data?.image, ...(data?.images || [])].filter(Boolean);

  // ✅ FIXED VALUES
  const variantPrice = Number(selectedVariant?.price || 0);
  const variantQty = Number(selectedVariant?.quantity || 0);
  const variantUnit = selectedVariant?.unit || "";

  return (
    <>
      <div
        className="container-xl py-4"
        style={{ margin: "auto", padding: 20 }}
      >
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title mb-1">
                <FcPaid /> View EPG Recipe
              </h2>
              <h4 className="text-muted">
                <StepRoutes />
              </h4>
            </div>
          </div>
        </div>

        {/* ===== MAIN FLEX ===== */}
        <div className="container mt-3">
          <div className="row g-4">
            {/* ================= LEFT SIDE ================= */}
            <div className="col-lg-4 col-md-5 col-12">
              <div className="d-flex flex-md-row flex-column gap-3">
                {/* THUMBNAILS */}
                <div
                  className="d-flex flex-md-column flex-row"
                  style={{ gap: 10 }}
                >
                  {images.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt=""
                      onClick={() => setSelectedImage(img)}
                      style={{
                        width: 70,
                        height: 70,
                        objectFit: "cover",
                        border:
                          selectedImage === img
                            ? "2px solid #ef4372"
                            : "1px solid #ddd",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    />
                  ))}
                </div>

                {/* MAIN IMAGE */}
                <div
                  className="flex-grow-1 d-flex justify-content-center align-items-center p-2"
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 10,
                    minHeight: 300,
                  }}
                >
                  <img
                    src={selectedImage}
                    alt=""
                    style={{
                      width: "100%",
                      maxHeight: 350,
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* ================= RIGHT SIDE ================= */}
            <div className="col-lg-8 col-md-7 col-12">
              <div className="card p-3 h-100">
                {/* PRODUCT DETAILS */}
                <h1 className="fw-bold">{data?.title}</h1>
                <p className="text-muted">{data?.subtitle}</p>
                <hr className="m-0 p-0"></hr>

                {/* PRICE */}
                <div className="mt-2 mb-2">
                  <span className="fs-2">
                    <div
                      style={{
                        padding: "8px 14px",
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        cursor: "pointer",
                        background: "#f9fafb",
                        color: "#000",
                      }}
                    >
                      <b>₹{data?.totalRecipePrice}</b>
                    </div>
                  </span>
                </div>

                <hr className="m-0 p-0"></hr>
                {/* DESCRIPTION */}
                <div className="mt-4">
                  <h3>Description</h3>
                  <p className="text-secondary" style={{ lineHeight: "22px" }}>
                    {data?.description}
                  </p>
                </div>

                {/* VARIANTS */}
                <div className="mt-4">
                  <h3>Recipe Products</h3>

                  <div className="border rounded">
                    {data?.variants?.map((variant, index) => (
                      <div
                        key={variant.id}
                        className="d-flex justify-content-between align-items-center border-bottom p-2"
                      >
                        <div>
                          <strong>{variant.product?.title}</strong>
                          <br />
                          <small className="text-muted">{variant.title}</small>
                          <div></div>
                          <small className="text-muted">
                            Quntity : {variant.quantity}
                          </small>
                        </div>

                        <div className="fw-bold text-success">
                          ₹{variant.price}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* PRODUCT DETAILS TABLE */}
                <div className="mt-4">
                  <h3>Recipe Details</h3>
                  <div
                    style={{
                      border: "1px solid #eee",
                      borderRadius: 10,
                      overflow: "hidden",
                    }}
                  >
                    {[
                      ["Recipe Name", data?.title],
                      ["Price", `₹${data?.totalRecipePrice}`],
                      ["Recipe Subtitle", data?.subtitle],
                      ["Available Qty", data?.quantity],
                      ["Unit", "Nos"],
                      ["Country", "India"],
                      ["Customer Care", "+91 98765 43210"],
                    ].map((row, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between"
                        style={{
                          padding: 10,
                          borderBottom: i !== 5 ? "1px solid #eee" : "none",
                        }}
                      >
                        <span className="text-muted">{row[0]}</span>
                        <span className="fw-semibold">{row[1]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-list justify-content-end">
            <SimpleButton
              buttonText="Edit Recipe"
              href={`/edit-epg-recipe/${id}`}
            />
            <SimpleButton buttonText="Cancel" type="secondary" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RecipeView;
